var map = {
	"./006-mozambique.svg": 51705,
	"./009-uganda.svg": 13750,
	"./010-nigeria.svg": 45644,
	"./013-tunisia.svg": 52219,
	"./014-nicaragua.svg": 84124,
	"./016-zambia.svg": 2441,
	"./017-wales.svg": 3085,
	"./019-qatar.svg": 20200,
	"./020-namibia.svg": 63745,
	"./022-european-union.svg": 77631,
	"./024-hawaii.svg": 68777,
	"./028-myanmar.svg": 43270,
	"./031-pakistan.svg": 6374,
	"./035-serbia.svg": 32832,
	"./036-scotland.svg": 53416,
	"./037-north-korea.svg": 28554,
	"./038-uruguay.svg": 96817,
	"./039-syria.svg": 89550,
	"./046-united-nations.svg": 68747,
	"./047-panama.svg": 61592,
	"./057-venezuela.svg": 90716,
	"./065-ukraine.svg": 14465,
	"./069-laos.svg": 74239,
	"./074-peru.svg": 74854,
	"./080-taiwan.svg": 37712,
	"./083-christmas-island.svg": 52572,
	"./084-ceuta.svg": 71452,
	"./088-corsica.svg": 50164,
	"./089-canary-islands.svg": 50590,
	"./092-cayman-islands.svg": 27284,
	"./100-abkhazia.svg": 41715,
	"./101-balearic-islands.svg": 3307,
	"./112-british-virgin-islands.svg": 96394,
	"./117-albania.svg": 41303,
	"./120-basque-country.svg": 11267,
	"./123-british-columbia.svg": 65491,
	"./136-galapagos-islands.svg": 75463,
	"./138-tonga.svg": 23270,
	"./139-st-lucia.svg": 96341,
	"./140-rapa-nui.svg": 20584,
	"./142-palau.svg": 66249,
	"./143-niue.svg": 509,
	"./148-vanuatu.svg": 69459,
	"./149-sierra-leone.svg": 70850,
	"./150-seychelles.svg": 84519,
	"./151-kosovo.svg": 27069,
	"./155-orkney-islands.svg": 77994,
	"./156-turks-and-caicos.svg": 53663,
	"./157-transnistria.svg": 789,
	"./158-tokelau.svg": 25284,
	"./160-st-vincent-and-the-grenadines.svg": 15771,
	"./161-south-sudan.svg": 30039,
	"./162-somaliland.svg": 18372,
	"./163-solomon-islands.svg": 14859,
	"./164-vietnam.svg": 41946,
	"./165-sint-maarten.svg": 87513,
	"./166-sint-eustatius.svg": 56419,
	"./167-saint-kitts-and-nevis.svg": 20845,
	"./168-saba-island.svg": 16805,
	"./169-pitcairn-islands.svg": 81151,
	"./170-palestine.svg": 41052,
	"./171-ossetia.svg": 19051,
	"./172-northern-marianas-islands.svg": 51297,
	"./173-nauru.svg": 85871,
	"./176-melilla.svg": 6936,
	"./188-virgin-islands.svg": 90760,
	"./190-vatican-city.svg": 69216,
	"./191-tubalu.svg": 38682,
	"./192-turkmenistan.svg": 66968,
	"./193-togo.svg": 13168,
	"./196-azores-islands.svg": 17812,
	"./197-suriname.svg": 93877,
	"./198-somalia.svg": 13132,
	"./199-sicily.svg": 94395,
	"./200-sardinia.svg": 78669,
	"./201-sao-tome-and-principe.svg": 29942,
	"./202-norfolk-island.svg": 17984,
	"./203-niger.svg": 87126,
	"./204-micronesia.svg": 98807,
	"./213-st-barts.svg": 8028,
	"./214-san-marino.svg": 52701,
	"./215-northen-cyprus.svg": 81547,
	"./222-sahrawi-arab-democratic-republic.svg": 54721,
	"./224-otan.svg": 13402,
	"./226-east-timor.svg": 47504,
	"./227-tibet.svg": 92014,
	"./229-papua-new-guinea.svg": 7129,
	"./233-madeira.svg": 67362,
	"./235-trinidad-and-tobago.svg": 71640,
	"./236-tajikistan.svg": 39855,
	"./238-sri-lanka.svg": 57627,
	"./242-zimbabwe.svg": 23472,
	"./243-rwanda.svg": 53949,
	"./248-samoa.svg": 36337,
	"./249-nepal.svg": 85024,
	"./259-senegal.svg": 6971,
	"./260-paraguay.svg": 11623,
	"./AD.svg": 73715,
	"./AE.svg": 2812,
	"./AF.svg": 87181,
	"./AG.svg": 38426,
	"./AI.svg": 79263,
	"./AM.svg": 15836,
	"./AO.svg": 65611,
	"./AR.svg": 56263,
	"./AS.svg": 19843,
	"./AT.svg": 39963,
	"./AU.svg": 99649,
	"./AW.svg": 44783,
	"./AX.svg": 21075,
	"./AZ.svg": 65514,
	"./BA.svg": 56264,
	"./BB.svg": 4775,
	"./BD.svg": 32930,
	"./BE.svg": 99818,
	"./BF.svg": 58943,
	"./BG.svg": 15433,
	"./BH.svg": 24026,
	"./BI.svg": 69654,
	"./BJ.svg": 18134,
	"./BM.svg": 2768,
	"./BN.svg": 781,
	"./BQ.svg": 53822,
	"./BR.svg": 77152,
	"./BS.svg": 33003,
	"./BT.svg": 32894,
	"./BW.svg": 25440,
	"./BY.svg": 74546,
	"./BZ.svg": 12271,
	"./CA.svg": 71413,
	"./CC.svg": 31465,
	"./CD.svg": 42103,
	"./CF.svg": 7756,
	"./CG.svg": 59974,
	"./CH.svg": 21986,
	"./CI.svg": 48900,
	"./CK.svg": 9315,
	"./CL.svg": 40689,
	"./CM.svg": 4451,
	"./CN.svg": 40491,
	"./CO.svg": 89613,
	"./CQ.svg": 32079,
	"./CR.svg": 16289,
	"./CU.svg": 69891,
	"./CV.svg": 7498,
	"./CW.svg": 81299,
	"./CY.svg": 57382,
	"./CZ.svg": 47413,
	"./DE.svg": 94531,
	"./DJ.svg": 48468,
	"./DK.svg": 42352,
	"./DM.svg": 50096,
	"./DO.svg": 18418,
	"./DZ.svg": 48024,
	"./EC.svg": 63237,
	"./EE.svg": 46427,
	"./EG.svg": 82466,
	"./EL.svg": 3312,
	"./EN.svg": 728,
	"./ER.svg": 10640,
	"./ES.svg": 9065,
	"./ET.svg": 15376,
	"./EU.svg": 38140,
	"./FI.svg": 32793,
	"./FJ.svg": 58233,
	"./FK.svg": 26811,
	"./FO.svg": 61276,
	"./FR.svg": 89251,
	"./GA.svg": 17785,
	"./GB.svg": 83334,
	"./GD.svg": 67192,
	"./GE.svg": 22191,
	"./GG.svg": 18964,
	"./GH.svg": 64595,
	"./GI.svg": 2727,
	"./GL.svg": 41297,
	"./GM.svg": 81457,
	"./GN.svg": 78688,
	"./GR.svg": 33659,
	"./GT.svg": 62346,
	"./GU.svg": 66720,
	"./GW.svg": 78586,
	"./HK.svg": 67144,
	"./HN.svg": 12784,
	"./HR.svg": 16054,
	"./HT.svg": 10253,
	"./HU.svg": 44892,
	"./ID.svg": 12425,
	"./IE.svg": 6795,
	"./IL.svg": 72390,
	"./IM.svg": 82082,
	"./IN.svg": 24024,
	"./IO.svg": 51047,
	"./IQ.svg": 67418,
	"./IR.svg": 56879,
	"./IS.svg": 92329,
	"./IT.svg": 4817,
	"./JE.svg": 87576,
	"./JM.svg": 75947,
	"./JO.svg": 3798,
	"./JP.svg": 62777,
	"./KE.svg": 21350,
	"./KG.svg": 2042,
	"./KH.svg": 94451,
	"./KM.svg": 4405,
	"./KR.svg": 30512,
	"./KW.svg": 58552,
	"./KZ.svg": 7556,
	"./LB.svg": 26206,
	"./LI.svg": 30868,
	"./LR.svg": 15597,
	"./LS.svg": 58833,
	"./LT.svg": 83332,
	"./LU.svg": 79747,
	"./LV.svg": 87151,
	"./LY.svg": 65600,
	"./MA.svg": 6876,
	"./MC.svg": 58444,
	"./MD.svg": 99210,
	"./ME.svg": 59031,
	"./MG.svg": 51719,
	"./MH.svg": 60456,
	"./MK.svg": 72554,
	"./ML.svg": 29648,
	"./MN.svg": 3875,
	"./MO.svg": 86764,
	"./MQ.svg": 12137,
	"./MR.svg": 81465,
	"./MS.svg": 31033,
	"./MT.svg": 97177,
	"./MU.svg": 36046,
	"./MV.svg": 84390,
	"./MW.svg": 51610,
	"./MX.svg": 67156,
	"./MY.svg": 64888,
	"./NL.svg": 35254,
	"./NO.svg": 53036,
	"./NZ.svg": 34652,
	"./OM.svg": 57109,
	"./PF.svg": 58261,
	"./PH.svg": 46869,
	"./PL.svg": 41257,
	"./PR.svg": 5325,
	"./PT.svg": 10251,
	"./RO.svg": 40202,
	"./RU.svg": 75015,
	"./SA.svg": 21404,
	"./SD.svg": 37390,
	"./SE.svg": 88880,
	"./SG.svg": 84729,
	"./SI.svg": 42530,
	"./SK.svg": 22263,
	"./SV.svg": 48722,
	"./TD.svg": 95701,
	"./TH.svg": 4129,
	"./TR.svg": 91677,
	"./TZ.svg": 26253,
	"./UK.svg": 40275,
	"./US.svg": 40442,
	"./UZ.svg": 92782,
	"./YE.svg": 68886,
	"./ZA.svg": 99364,
	"./bo.svg": 77169,
	"./map.svg": 15399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14060;